<div class="d-flex flex-column">
  <app-file-upload-input
    [class.d-none]="!keepUploadInputVisible && !multiple && selectedFiles?.length"
    #fileInput
    [ngModel]="selectedFiles"
    [accept]="accept"
    [controlId]="controlId"
    [inputName]="inputName"
    [multiple]="multiple"
    (selectedFilesChange)="onSelectedFilesChange($event)">
    <ng-content select="[input-copy]"></ng-content>
  </app-file-upload-input>
  <ng-content select="[input-hint]"></ng-content>
  <ng-content select="[input-error]"></ng-content>
  <div
    class="file-list"
    [style.margin-top.rem]="!multiple && !keepUploadInputVisible ? 0 : 1.25"
    *ngIf="selectedFiles?.length">
    <div *ngFor="let file of selectedFiles; let i = index">
      <label *ngIf="fileLabel" class="form-input-label mb-1">{{ fileLabel }}</label>
      <app-file-list-item
        [fileName]="file.name"
        [fileSizeInBytes]="file.size"
        [disabled]="disabled"
        [hasError]="!!getFileError(i)"
        [thumbnailUrl]="getThumbnailUrl(file)"
        action="remove"
        (removeClicked)="removeFile(file)"
        (previewClicked)="previewFile(file)" />
      <span *ngIf="getFileError(i)?.maxFileSize" class="error-text" i18n>
        File can not exceed {{ maxFileSizeInMb }} MB
      </span>
    </div>
  </div>
</div>
